// src/components/Loader.jsx
import React from "react";
import { useSelector } from "react-redux";

const Loader = () => {
  // change selector to your global loading flag or combine multiple flags
  const authLoading = useSelector((s) => s.auth?.loading);
  const uiLoading = useSelector((s) => s.ui?.loading); // optional
  const isLoading = authLoading || uiLoading;

  if (!isLoading) return null;

  return (
    <div className="global-loader">
      {/* your spinner markup */}
      <div className="spinner">Loading...</div>
    </div>
  );
};

export default Loader;
